"use client";

import { usePusher } from "@lib/hooks/usePusher";

export default function PusherProvider({ children }) {
  // Initialize Pusher with authentication
  usePusher();

  return children;
}